import { defineCustomElement, getAttribute, NectaryElement, updateAttribute } from '../utils';
const templateHTML = '<style>:host{display:contents;--sinch-comp-emoji-vertical-align:initial}#image{vertical-align:var(--sinch-comp-emoji-vertical-align);pointer-events:none;width:var(--sinch-global-size-icon,48px);height:var(--sinch-global-size-icon,48px)}</style><img id="image" src="" alt="" loading="lazy"/>';
import { getEmojiBaseUrl, getEmojiUrl } from './utils';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-emoji', class extends NectaryElement {
  #$img;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$img = shadowRoot.querySelector('#image');
  }
  connectedCallback() {
    super.connectedCallback();
    this.#updateChar();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  static get observedAttributes() {
    return ['char'];
  }
  attributeChangedCallback(name, _, newVal) {
    switch (name) {
      case 'char':
        {
          this.#$img.alt = newVal ?? '';
          this.#updateChar();
          break;
        }
    }
  }
  set char(value) {
    updateAttribute(this, 'char', value);
  }
  get char() {
    return getAttribute(this, 'char', '');
  }
  #updateChar() {
    if (!this.isDomConnected) {
      return;
    }
    this.#$img.src = getEmojiUrl(getEmojiBaseUrl(this), this.char);
  }
});